/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';
	let lang = location.pathname.split('/')[1];
	let detailText = '詳細をみる';
	if(lang == 'en') {
		detailText = 'View details';
	}
	const nntop = () => {
		if(document.querySelectorAll('.js-nn-top-item').length) {
			const getJSONfilesnn = (_id) => {
				return `/${lang}/ajax/newway_newvalue/theme/${_id}/list.json`;
			};
			document.querySelectorAll('.js-nn-top-item').forEach(function(val, index){
				fetch(getJSONfilesnn(val.querySelector('.rt_bn_cf_art_article_tag_key').textContent)).then(function (data) {
					return data.json();
				}).then(function (data) {
					// console.log(data.rt_bn_nwnv,'data');
					let HTML1 = '';
					let HTML2 = '';
					let datepick = '';
					if(!(data.rt_bn_nwnv.length == 0)) {
						datepick = data.rt_bn_nwnv[0].rt_cf_art_date.content;
						if(data.rt_bn_nwnv[0].rt_cf_art_href.href == '#') {
							HTML1 = `<div class="newway_newvalue-block01-contents-item-a">
								<img src="/common/images/pickup.webp" alt="PICK UP" class="newway_newvalue-block01-contents-item-pickup">
								<figure class="newway_newvalue-block01-contents-item-img">
									<img src="${data.rt_bn_nwnv[0].rt_cf_art_thum_img.src}" alt="" class="width-u-100">
								</figure>
								<div class="newway_newvalue-block01-contents-item-text">
									<p class="news-slider-item-text-day ff_lato mod-auto-center">${datepick}</p>
									<h2 class="mod-head02">${data.rt_bn_nwnv[0].rt_cf_art_title.content[0]}</h2>
									<p class="mod-spacer_20">${data.rt_bn_nwnv[0].rt_cf_art_nwnv_name.content}</p>
								</div>
							</div>`;
						} else if(data.rt_bn_nwnv[0].rt_cf_art_href.target) {
							HTML1 = `<a href="${data.rt_bn_nwnv[0].rt_cf_art_href.href}" target="${data.rt_bn_nwnv[0].rt_cf_art_href.target}" class="newway_newvalue-block01-contents-item-a mod-link_img_text">
								<img src="/common/images/pickup.webp" alt="PICK UP" class="newway_newvalue-block01-contents-item-pickup">
								<figure class="newway_newvalue-block01-contents-item-img">
									<img src="${data.rt_bn_nwnv[0].rt_cf_art_thum_img.src}" alt="" class="width-u-100">
								</figure>
								<div class="newway_newvalue-block01-contents-item-text">
								<p class="news-slider-item-text-day ff_lato mod-auto-center">${datepick}</p>
									<h2 class="mod-head02">${data.rt_bn_nwnv[0].rt_cf_art_title.content[0]}</h2>
									<p class="mod-spacer_20">${data.rt_bn_nwnv[0].rt_cf_art_nwnv_name.content}</p>
									<div class="mod-spacer_20 ta_tab_right">
										<p class="mod-link01 _gray _text">
											<span class="fw_500">${detailText}</span>
											<svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#arrow_right3"></use></svg>
										</p>
									</div>
								</div>
							</a>`;
						} else {
							HTML1 = `<a href="${data.rt_bn_nwnv[0].rt_cf_art_href.href}" class="newway_newvalue-block01-contents-item-a mod-link_img_text">
								<img src="/common/images/pickup.webp" alt="PICK UP" class="newway_newvalue-block01-contents-item-pickup">
								<figure class="newway_newvalue-block01-contents-item-img">
									<img src="${data.rt_bn_nwnv[0].rt_cf_art_thum_img.src}" alt="" class="width-u-100">
								</figure>
								<div class="newway_newvalue-block01-contents-item-text">
								<p class="news-slider-item-text-day ff_lato mod-auto-center">${datepick}</p>
									<h2 class="mod-head02">${data.rt_bn_nwnv[0].rt_cf_art_title.content[0]}</h2>
									<p class="mod-spacer_20">${data.rt_bn_nwnv[0].rt_cf_art_nwnv_name.content}</p>
									<div class="mod-spacer_20 ta_tab_right">
										<p class="mod-link01 _gray _text">
											<span class="fw_500">${detailText}</span>
											<svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#arrow_right3"></use></svg>
										</p>
									</div>
								</div>
							</a>`;
						}
						val.querySelector('.js-nn-top-item-01').insertAdjacentHTML('beforeend', HTML1);
					}
					if(data.rt_bn_nwnv.length == 1) {
						val.classList.remove('di_none');
						val.querySelector('.js-nn-top-item-02Wrap').classList.add('di_none');
					} else if(data.rt_bn_nwnv.length == 2) {
						data.rt_bn_nwnv.forEach(function(slideval, slideindex){
							if(!(slideindex == 0)) {
								// console.log(slideval);
								datepick = slideval.rt_cf_art_date.content;
								if(slideval.rt_cf_art_href.href == '#') {
									HTML2 += `<li class="mod-slider02-item opacity swiper-slide js-nn-top-item-02-item">
										<div class="di_block">
											<span aria-hidden="true" class="_obj"></span>
											<figure class="" data-mh="mod-slider02-item-text-fiure${index}">
												<img src="${slideval.rt_cf_art_thum_img.src}" alt="" class="width-u-100">
											</figure>
											<div class="mod-slider02-item-text">
												<p class="news-slider-item-text-day ff_lato" data-mh="nwnv_day_pickup">${datepick}</p>
												<p class="mod-slider02-item-text-title" data-mh="mod-slider02-item-text-title${index}">${slideval.rt_cf_art_title.content[0]}</p>
												<p class="mod-spacer_20" data-mh="mod-slider02-item-text-lead${index}">${slideval.rt_cf_art_nwnv_name.content}</p>
											</div>
										</div>
									</li>`;
								} else if(slideval.rt_cf_art_href.target) {
									HTML2 += `<li class="mod-slider02-item opacity swiper-slide js-nn-top-item-02-item">
									<a href="${slideval.rt_cf_art_href.href}" target="${slideval.rt_cf_art_href.target}" class="di_block opacity">
										<span aria-hidden="true" class="_obj"></span>
										<figure class="" data-mh="mod-slider02-item-text-fiure${index}">
											<img src="${slideval.rt_cf_art_thum_img.src}" alt="" class="width-u-100">
										</figure>
										<div class="mod-slider02-item-text">
											<p class="news-slider-item-text-day ff_lato" data-mh="nwnv_day_pickup">${datepick}</p>
											<p class="mod-slider02-item-text-title" data-mh="mod-slider02-item-text-title${index}">${slideval.rt_cf_art_title.content[0]}</p>
											<p class="mod-spacer_20" data-mh="mod-slider02-item-text-lead${index}">${slideval.rt_cf_art_nwnv_name.content}</p>
											<div class="mod-spacer_20 ta_right">
												<p class="mod-link01 _gray _text">
													<span class="fw_500">${detailText}</span>
													<svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#arrow_right3"></use></svg>
												</p>
											</div>
										</div>
									</a>
								</li>`;
								} else {
									HTML2 += `<li class="mod-slider02-item opacity swiper-slide js-nn-top-item-02-item">
										<a href="${slideval.rt_cf_art_href.href}" class="di_block opacity">
											<span aria-hidden="true" class="_obj"></span>
											<figure class="" data-mh="mod-slider02-item-text-fiure${index}">
												<img src="${slideval.rt_cf_art_thum_img.src}" alt="" class="width-u-100">
											</figure>
											<div class="mod-slider02-item-text">
												<p class="news-slider-item-text-day ff_lato" data-mh="nwnv_day_pickup">${datepick}</p>
												<p class="mod-slider02-item-text-title" data-mh="mod-slider02-item-text-title${index}">${slideval.rt_cf_art_title.content[0]}</p>
												<p class="mod-spacer_20" data-mh="mod-slider02-item-text-lead${index}">${slideval.rt_cf_art_nwnv_name.content}</p>
												<div class="mod-spacer_20 ta_right">
													<p class="mod-link01 _gray _text">
														<span class="fw_500">${detailText}</span>
														<svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#arrow_right3"></use></svg>
													</p>
												</div>
											</div>
										</a>
									</li>`;
								}
							}
						});
						val.querySelector('.js-nn-top-item-02-item').insertAdjacentHTML('beforeend', HTML2);
						let sliderid = 'mod-slider02_'+index;
						// // 同ページに複数スライダー設置の際にユニークIDを付与
						val.querySelector('.js-nn-top-item-02').setAttribute('id',sliderid);
						sliderid = '#'+sliderid;
						new Swiper(sliderid, {
							slidesPerView: 1,
							spaceBetween: 0,
						 	// loop: true,
							// loopAdditionalSlides: 1,
							speed: 1000,
							autoplay: false,
							watchSlidesProgress: true,
							navigation: {
								nextEl: sliderid + ' + .mod-slider02-control .swiper-button-next',
								prevEl: sliderid + ' + .mod-slider02-control .swiper-button-prev',
							},
							breakpoints: {
							1024: {
								slidesPerView: 1,
							},
							},
						});
						val.querySelector(sliderid).classList.add('width-u-50');
						val.querySelector(sliderid).classList.add('width-tab-100');
						val.classList.remove('di_none');
						setTimeout(() => { 
							const $elements = document.querySelectorAll( '[data-mh]' );
							const groups = new Map();
				
							$elements.forEach( ele => { ele.style.height = 'auto'; } ); // 初期化
				
							$elements.forEach( ele => {
								const attributeName = ele.getAttribute( 'data-mh' );
								if ( !groups.has( attributeName ) ) {
									groups.set( attributeName, [] );
								}
								groups.get( attributeName ).push( ele );
							} );
							groups.forEach( group => {
								const attributeGroups = new Map();
								group.forEach( ele => {
									const attributeName = ele.getAttribute( 'data-mh' );
									const topPosition = ele.getBoundingClientRect().top;
									const key = attributeName + '_' + topPosition;
									if ( !attributeGroups.has( key ) ) {
										attributeGroups.set( key, [] );
									}
									attributeGroups.get( key ).push( ele );
								} );
								attributeGroups.forEach( (item) => {
									const maxHeight = Math.max( ...item.map( ele => ele.offsetHeight ) );
									item.forEach( (ele2) => {
										ele2.style.height = `${maxHeight}px`;
									});
								});
							} );
						}, 	300);
					} else if(data.rt_bn_nwnv.length == 3) {
						data.rt_bn_nwnv.forEach(function(slideval, slideindex){
							if(!(slideindex == 0)) {
								// console.log(slideval);
								datepick = slideval.rt_cf_art_date.content;
								if(slideval.rt_cf_art_href.href == '#') {
									HTML2 += `<li class="mod-slider02-item opacity swiper-slide js-nn-top-item-02-item">
										<div class="di_block">
											<span aria-hidden="true" class="_obj"></span>
											<figure class="" data-mh="mod-slider02-item-text-fiure${index}">
												<img src="${slideval.rt_cf_art_thum_img.src}" alt="" class="width-u-100">
											</figure>
											<div class="mod-slider02-item-text">
												<p class="news-slider-item-text-day ff_lato" data-mh="nwnv_day_pickup">${datepick}</p>
												<p class="mod-slider02-item-text-title" data-mh="mod-slider02-item-text-title${index}">${slideval.rt_cf_art_title.content[0]}</p>
												<p class="mod-spacer_20" data-mh="mod-slider02-item-text-lead${index}">${slideval.rt_cf_art_nwnv_name.content}</p>
											</div>
										</div>
									</li>`;
								} else if(slideval.rt_cf_art_href.target) {
									HTML2 += `<li class="mod-slider02-item opacity swiper-slide js-nn-top-item-02-item">
									<a href="${slideval.rt_cf_art_href.href}" target="${slideval.rt_cf_art_href.target}" class="di_block opacity">
										<span aria-hidden="true" class="_obj"></span>
										<figure class="" data-mh="mod-slider02-item-text-fiure${index}">
											<img src="${slideval.rt_cf_art_thum_img.src}" alt="" class="width-u-100">
										</figure>
										<div class="mod-slider02-item-text">
											<p class="news-slider-item-text-day ff_lato" data-mh="nwnv_day_pickup">${datepick}</p>
											<p class="mod-slider02-item-text-title" data-mh="mod-slider02-item-text-title${index}">${slideval.rt_cf_art_title.content[0]}</p>
											<p class="mod-spacer_20" data-mh="mod-slider02-item-text-lead${index}">${slideval.rt_cf_art_nwnv_name.content}</p>
											<div class="mod-spacer_20 ta_right">
												<p class="mod-link01 _gray _text">
													<span class="fw_500">${detailText}</span>
													<svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#arrow_right3"></use></svg>
												</p>
											</div>
										</div>
									</a>
								</li>`;
								} else {
									HTML2 += `<li class="mod-slider02-item opacity swiper-slide js-nn-top-item-02-item">
										<a href="${slideval.rt_cf_art_href.href}" class="di_block opacity">
											<span aria-hidden="true" class="_obj"></span>
											<figure class="" data-mh="mod-slider02-item-text-fiure${index}">
												<img src="${slideval.rt_cf_art_thum_img.src}" alt="" class="width-u-100">
											</figure>
											<div class="mod-slider02-item-text">
												<p class="news-slider-item-text-day ff_lato" data-mh="nwnv_day_pickup">${datepick}</p>
												<p class="mod-slider02-item-text-title" data-mh="mod-slider02-item-text-title${index}">${slideval.rt_cf_art_title.content[0]}</p>
												<p class="mod-spacer_20" data-mh="mod-slider02-item-text-lead${index}">${slideval.rt_cf_art_nwnv_name.content}</p>
												<div class="mod-spacer_20 ta_right">
													<p class="mod-link01 _gray _text">
														<span class="fw_500">${detailText}</span>
														<svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#arrow_right3"></use></svg>
													</p>
												</div>
											</div>
										</a>
									</li>`;
								}
							}
						});
						val.querySelector('.js-nn-top-item-02-item').insertAdjacentHTML('beforeend', HTML2);
						let sliderid = 'mod-slider02_'+index;
						// // 同ページに複数スライダー設置の際にユニークIDを付与
						val.querySelector('.js-nn-top-item-02').setAttribute('id',sliderid);
						sliderid = '#'+sliderid;
						new Swiper(sliderid, {
							slidesPerView: 1,
							spaceBetween: 0,
						 	// loop: true,
							// loopAdditionalSlides: 1,
							speed: 1000,
							autoplay: false,
							watchSlidesProgress: true,
							navigation: {
								nextEl: sliderid + ' + .mod-slider02-control .swiper-button-next',
								prevEl: sliderid + ' + .mod-slider02-control .swiper-button-prev',
							},
							breakpoints: {
							1024: {
								slidesPerView: 2,
							},
							},
						});
						val.classList.remove('di_none');
						setTimeout(() => { 
							const $elements = document.querySelectorAll( '[data-mh]' );
							const groups = new Map();
				
							$elements.forEach( ele => { ele.style.height = 'auto'; } ); // 初期化
				
							$elements.forEach( ele => {
								const attributeName = ele.getAttribute( 'data-mh' );
								if ( !groups.has( attributeName ) ) {
									groups.set( attributeName, [] );
								}
								groups.get( attributeName ).push( ele );
							} );
							groups.forEach( group => {
								const attributeGroups = new Map();
								group.forEach( ele => {
									const attributeName = ele.getAttribute( 'data-mh' );
									const topPosition = ele.getBoundingClientRect().top;
									const key = attributeName + '_' + topPosition;
									if ( !attributeGroups.has( key ) ) {
										attributeGroups.set( key, [] );
									}
									attributeGroups.get( key ).push( ele );
								} );
								attributeGroups.forEach( (item) => {
									const maxHeight = Math.max( ...item.map( ele => ele.offsetHeight ) );
									item.forEach( (ele2) => {
										ele2.style.height = `${maxHeight}px`;
									});
								});
							} );
						}, 	300);
					}
				});
			});
		}
	};
	nntop();
})(window.FUNCTIONS);
